<h1 class="page-header">Issue Challenge</h1>
<fun-battle-record-challenge
   [formBusy]="formBusy"
   [formDisabled]="formDisabled"
   [users]="users"
   [currentUser]="currentUser | async"
   (formSubmitted)="onFormSubmitted($event)"
> </fun-battle-record-challenge>
